<template>
    <div class="inquire" v-cloak>
      <div class="data-bg">
      <app-header></app-header>
        <div class="data-banner">
          <div class="data-title-box">
            <p class="data-title"><span>{{ $t('xdata.Nav_qqwltx') }}</span></p>
            <!-- <span class="data-sub">Shanghai Global ICT 利用资源优势，直接依托中国电信和中国联通的互联网核心网，为客户提供各种优质的互联网产品和服务。 提供包括虚拟主机、邮件系统、托管服务器或VIP机房、宽带、数字数据网络、服务器租赁等基础服务。我们还提供增值服务，即网络利用率监测、网络安全、数据备份和恢复、服务器托管维护，以满足不同客户的所有需求</span> -->
          </div>
        </div>
      </div>
      <div class="u-flex u-flex-center data-content">
        <data-item :title="$t('xdata.Ope_hlw')" :sub="$t('xdata.Ope_hlwt1')">
        </data-item>
        <data-item :title="$t('xdata.Ope_sbzy')" :sub="$t('xdata.Ope_sbzyt1')">
        </data-item>
        <data-item :title="$t('xdata.Ope_yfw')" :sub="$t('xdata.Ope_yfwt1')">
        </data-item>
      </div>
      <div class="data-list-box">
          <div class="data-list-bg">
            <div class="data-list">
              <div class="data-list-item u-flex u-flex-between">
                <img src="@/assets/img/data/xint.jpg" class="data-list-item-right" v-if="lang == 'zh-CN' "/>
                <img src="@/assets/img/data/xint_en.jpg" class="data-list-item-right" v-else/>
                <div class="data-list-item-left">
                  <p class="data-list-item-name">{{ $t('xdata.Ope_fwtg') }}</p>
                  <p class="data-list-item-sub data-list-item-mb">{{ $t('xdata.Ope_fwtgt1') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Ope_fwtgt2') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Ope_fwtgt3') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="data-list-bg">
            <div class="data-list">
              <div class="data-list-item u-flex u-flex-between">
                <div class="data-list-item-left">
                  <p class="data-list-item-name">{{ $t('xdata.Ope_qqhz') }}</p>
                  <p class="data-list-item-sub data-list-item-mb">{{ $t('xdata.Ope_qqhzt1') }}</p>
                </div>
                <img src="@/assets/img/data/sd1.png" class="data-list-item-right"/>
              </div>
            </div>
          </div>
        </div>
      <app-footer></app-footer>
    </div>
  </template>
  
  <script>
  
import Header from "@/components/header";
import Footer from "@/components/footer";
import DataItem from "@/components/dataItem";

export default {
    components: {
      "app-header": Header,
      "app-footer": Footer,
      "data-item": DataItem,
    },
    name: "service",
    data() {
      return {
        lang:''
      };
    },
    created(){
      this.lang = localStorage.getItem('lang') 
    },
    mounted() {
    },
    methods: {
    
    }
  };
  </script>
  <style scoped>
    .data-bg {
      width: 100%;
      background: url('../../assets/img/data_bg.jpg') no-repeat fixed center center / 100% auto;
    }
    .data-banner{
      height: 300px;
      background: rgba(0, 0, 0, 0.3);
    }
    .data-title-box{
      padding-top: 60px;
      width: 1200px;
      margin: 0 auto;
    }
    .data-title{
      font-size: 32px;
      color: #fff;
      margin-bottom: 20px;
    }
    .data-sub{
      font-size: 14px;
      display: inline-block;
      width: 70%;
      color: #fff;
      line-height: 1.5;

    }
    .data-content{
      width: 1200px;
      background: #fff;
      margin: 50px auto;
    }
    .data-item:last-of-type{
      margin-right: 0px;
    }
    .data-list-box{
      padding: 50px 0 100px;
      background: #f4f4f4;
    }
    .data-list-bg{
      padding: 50px 0 80px;
    }
    .data-list{
      width: 1200px;
      padding-left: calc((100vw - 1200px) / 2);
      padding-right: 0px;
      background: #fff;
    }
    .data-list-bg:nth-of-type(2n){
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }
    .data-list-bg:nth-of-type(2n) .data-list{
      padding-right: calc((100vw - 1200px) / 2);
      padding-left: 0px;
    }
    .data-list-item{
      padding: 20px 0;
    }
    .data-list-item:last-of-type{
      border-bottom: none;
    }
    .data-list-item-left{
      width: 600px;
      padding: 0 30px;
    }
    .data-list-item-right{
      width: 500px;
      position: relative;
      bottom: -70px;
      left: -50px;
      border: 1px solid #f4f4f4;
    }
    .data-list-bg:nth-of-type(2n) .data-list-item-right{
      left: 50px;
    }
    .data-list-item-name{
      font-size: 24px;
      margin-bottom: 40px;
      font-weight: bold;
      position: relative;
      margin-top: 20px;
    }
    .data-list-item-name::after{
      content: '';
      display: block;
      position: absolute;
      bottom: -10px;
      left: 0px;
      width: 100px;
      height: 4px;
      border-radius: 4px;
      background: #009DE4;
    }
    .data-list-item-sub{
      line-height: 1.5;
    }
    .data-list-item-mb{
      margin-bottom: 20px;
    }
  </style>
  


// WEBPACK FOOTER //
// src/views/services/operation.vue